module.exports = __webpack_public_path__ + "img/footer_company_06.41f1254b.png";